import React, {Component} from 'react';
import {connect} from 'react-redux';
import GameLayout from '../../styled/GameLayout'
import Container from '../../styled/Container';
import TextContainer from '../../styled/TextContainer';
import CaptionContainer from '../../styled/CaptionContainer';
import GameAreaLayout from '../../styled/GameAreaLayout';
import LifeCounter from '../LifeCounter';
import KeyBoard from '../KeyBoard';
import WordDisplay from "../WordDisplay";

@connect(state => {
  return {
    level: state.game.level,
    totalLevels: state.game.totalLevels,
    life: state.game.life,
    hint: state.game.hint
  }
})
class GameArea extends Component {
  render() {
    return (
      <GameLayout>
        <GameAreaLayout>
          <LifeCounter/>
          <Container justifyContent='space-around' padding={'0 2px 30px 2px'}>
            <CaptionContainer>
              Уровень {this.props.level + 1} / {this.props.totalLevels}
            </CaptionContainer>
            <CaptionContainer>
              Жизней {this.props.life} / 10
            </CaptionContainer>
          </Container>
          <Container padding={'0 0 30px 0'}>
            <WordDisplay />
          </Container>
          <Container
            width={'410px'}
            padding={'0 0 40px 0'}
          >
            <TextContainer>{this.props.hint}</TextContainer>
          </Container>
          <KeyBoard />
        </GameAreaLayout>
      </GameLayout>
    );
  }
}

export default GameArea;
